module.exports = __webpack_public_path__ + "img/maccabi-haifa-logo-icon.39fa49ef.png";